import { useDocument } from "@/composables/useFirestore";
import { db } from "@/firebase";
import { useUserStore } from "@/store/user";
import { supervisorOrgFullPath, type SupervisorOrg } from "@aircap/common/supervisorOrg";
import { doc } from "firebase/firestore";
import { computed } from "vue";

export const useSupervisorOrg = () => {
  const user = useUserStore();
  const supervisorOrgRef = computed(() =>
    user.supervisorOrgId
      ? doc<SupervisorOrg>(db, supervisorOrgFullPath(user.supervisorOrgId))
      : null,
  );
  const { data: supervisorOrg, pending: loadingSupervisorOrg } =
    useDocument<SupervisorOrg>(supervisorOrgRef);

  return { supervisorOrgRef, supervisorOrg, loadingSupervisorOrg };
};
